// AdminRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../login/authContext"; // adapte le chemin si besoin

const AdminRoute = ({ children }) => {
  const { user, isAdmin, loading, login } = useAuth();

  if (loading) return <p>Chargement...</p>;

  if (!user) {
    return (
      <div className="text-center mt-20">
        <p className="mb-4 text-xl">Connecte-toi pour accéder à cette page admin</p>
        <button
          onClick={login}
          className="bg-purple-700 hover:bg-purple-800 text-white px-6 py-3 rounded-full"
        >
          Connexion Google
        </button>
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/unauthorized" />;
  }

  return children;
};

export default AdminRoute;
